import axiosInstance from 'api/axiosConfig'
import { ENDPOINTS } from 'api/endpoints'

export type ConfirmEmailResult = {
  ok: boolean
  email: string | null
  firebaseSub: string | null
  alreadyConfirmed?: boolean
}

export async function confirmEmailToken(
  token: string
): Promise<ConfirmEmailResult> {
  try {
    const res = await axiosInstance.get<{
      success?: boolean
      data?: {
        email?: string | null
        firebaseSub?: string | null
        alreadyConfirmed?: boolean
      }
    }>(ENDPOINTS.EMAIL_CONFIRM.BASE, {
      params: { token },
      timeout: 20000,
    })
    return {
      ok: Boolean(res.data?.success),
      email:
        typeof res.data?.data?.email === 'string' ? res.data.data.email : null,
      firebaseSub:
        typeof res.data?.data?.firebaseSub === 'string'
          ? res.data.data.firebaseSub
          : null,
      alreadyConfirmed: Boolean(res.data?.data?.alreadyConfirmed),
    }
  } catch {
    return { ok: false, email: null, firebaseSub: null }
  }
}

export async function requestEmailConfirmation(payload?: {
  email?: string
  name?: string
  force?: boolean
}): Promise<{ sent: boolean; alreadyConfirmed: boolean }> {
  const res = await axiosInstance.post(ENDPOINTS.EMAIL_CONFIRM.BASE, payload ?? {})
  return {
    sent: Boolean(res.data?.data?.sent),
    alreadyConfirmed: Boolean(res.data?.data?.alreadyConfirmed),
  }
}
